module.exports = __webpack_public_path__ + "static/0064-90d9c571cc6c67d214f71571408a0a2c.png";